/* Funk Firm — unified scroll-reveal motion.

   One IntersectionObserver watches every element with .funk-reveal or
   .funk-reveal-stagger. When the element scrolls into view, .is-in-view
   is added — the CSS in funk-overrides.css handles the actual transition
   (transform + opacity only, 550ms, cubic-bezier(0.2, 0.6, 0.2, 1)).

   Once per element: the observer unobserves after firing, so scrolling
   back up doesn't re-play.

   Reduced-motion users are fully respected by the CSS (it sets opacity:1
   and transform:none, transition:none), and we also short-circuit here so
   we don't bother running the observer at all.
*/

(function () {
  'use strict';

  // Idempotent: only initialise once even if this script is referenced twice.
  if (window.__funkMotionInit) return;
  window.__funkMotionInit = true;

  function init() {
    var selector = '.funk-reveal, .funk-reveal-stagger';
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    // Respect prefers-reduced-motion. CSS already covers this, but we
    // skip observation entirely to keep work off the main thread.
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      nodes.forEach(function (n) { n.classList.add('is-in-view'); });
      return;
    }

    // Fallback for very old browsers — just reveal everything.
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in-view'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          obs.unobserve(entry.target);
        }
      }
    }, {
      // Reveal slightly before the element is fully in view — feels
      // natural rather than late.
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08,
    });

    nodes.forEach(function (n) { observer.observe(n); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
